import React from 'react'
import { Box } from 'components/ds'
import styles from './switcher-popover-avatar.module.css'

export function SwitcherPopoverAvatar({
  name,
  imageUrl,
}: {
  name: string
  imageUrl?: string
}) {
  return (
    <Box
      mr="2"
      flexShrink={'0'}
      width="32px"
      height="32px"
      overflow="hidden"
      className={styles['switcher-popover-avatar-box']}
    >
      {imageUrl && (
        <img
          src={imageUrl}
          alt={`${name} logo`}
          width="32px"
          height="32px"
          className={styles['switcher-popover-avatar-img']}
        />
      )}
    </Box>
  )
}
